<template>
    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_user_contracts" style="margin-top: 13px !important; cursor:pointer">
      <thead style="background-color: #F2F3F4;">
        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
          <th class=" px-4 ">{{$t("contract.type")}}</th>
          <th class=" px-4 ">{{$t("contract.duration")}}</th>
          <th class=" px-4 ">{{$t("contract.salaire")}}</th>
          <th class=" px-4 ">{{$t("contract.active")}}</th>
          <th>{{$t("actions")}}</th>
        </tr>
      </thead>
    </table>
</template> 

<script setup>

import {ref,onMounted,watch , nextTick} from "vue";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import Ls from "@/services/ls";
import { useI18n } from 'vue-i18n'
import { useLocales } from '@/composables/locales';
import Card from "@/Modules/CRM/components/Card";
import {Theme} from "@/composables/theming";
import {useSwal} from "@/composables/useSwal";
import {useHasAbility} from "@/composables/hasAbility";
import { useFormatAmount } from "@/composables/formatAmount";
import { computed } from "vue";

const table = ref(null)
const formEdit = ref({})
const store = useStore()

const { t } = useI18n({ useScope: 'global' })
const {locale, datatableLocaleUrl} = useLocales()
const {showSwal} = useSwal()
const { can } = useHasAbility()
const { formatAmount, formatNumber } = useFormatAmount()

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])

function fetchDatas() {

const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

table.value = $("#kt_datatable_user_contracts").DataTable({
  destroy : true,
  responsive: !0,
  searchDelay: 500,
  processing: !0,
  serverSide: !0,
  pageLength:pageLimit ||  5,
  lengthMenu: [5, 10, 25, 50, 75, 100 ],
  order: [[ 0, 'desc']],
  ajax: {
    url: BASE_URL+"/get/user/employee/contract/datatables",
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      request.setRequestHeader("Company", Ls.get('current.company'));
      },
    data:  function ( d ) {

    }
  },
  columns: [{data: "contract_type"},{data: "start_date"},{data: "salary"},{data: "is_active"}, {data: "Actions", responsivePriority: -1}],

  columnDefs: [
  
    {
        targets: -5,
        orderable: !1,
        render:  (t, a, e, l) =>  {
          return '<span class="nameRow' + l.row + '">' + t?.toUpperCase() + "</span>";
        },
    },
    {
        targets: -4,
        orderable: !1,
        render:  (t, a, e, l) =>  {
          return '<span>'+ e.start_date + ' - '+ e.end_date + '  </span>';
        },
    },
    {
        targets: -3,
        orderable: !1,
        className: "dt-center clickable",
        render:  (t, a, e, l) =>  {
          return '<span class="nameRow' + l.row + '">' + formatAmount(t) + "</span>";

        }
    },

    {
        targets: -2,
        orderable: !1,
        className: "dt-center clickable",
        render:  (t, a, e, l) =>  {
          return '<span class="nameRow' + l.row + '">' + t ? i18n.global.t("label.yes") : i18n.global.t("label.no") + "</span>";
        }
    },

    {
      width: "16%",
      targets: -1,
      "className": "dt-center",
      title: "Actions",
      orderable: !1,
      render: (t, a, e, l) => {
        let render = '';
       
        if(true) render += `<a href="javascript:;" data-row="${l.row}" 
                data-id="${e.id}" data-end="${e.end_date}" data-start="${e.start_date}"
                class="btn btn-sm btn-clean btn-icon download_btn" title="${i18n.global.t('button.delete')}"><i data-row="${l.row}" data-id="${e.id}" data-end="${e.end_date}" data-firstname="${e.firstname}" data-lastname="${e.lastname}" data-start="${e.start_date}" class="fas fa-download fs-2" style="color: ${Theme.gray}"></i></a>`;
        return render;
      },
    },

  ],
  language: {
    url:  datatableLocaleUrl.value
  }
});

}



$(document).on("click", "#kt_datatable_user_contracts .download_btn", (e) => {
  let data = {
    id: e.target.getAttribute('data-id'), 
    name:e.target.getAttribute('data-start')+'_'+e.target.getAttribute('data-end')+'.pdf'
  }
  downloadContract(data)
});

async function downloadContract(id){
  try {
        await store.dispatch('contracts/downloadContract', id)
        reloadDatatable()
        window.toastr.success(t('notification.contract_downloded'))
      } catch (e) {
      }
}


watch(() => locale.value, () => {
  nextTick(()=>   fetchDatas())
})

onMounted(() => {
  fetchDatas()
})

</script>
<style>
.end{
  display: flex;
  justify-content: end;
}
</style>